import { Badge } from "antd";

import { IndicatorBadgeProps } from "./types";

const IndicatorBadge = ({ children, ...props }: IndicatorBadgeProps) => {
  return <Badge {...props}>{children}</Badge>;
};

export default IndicatorBadge;
